import React from 'react';
import { MapPin, Star, Fish, ArrowRight } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { motion } from 'framer-motion';
export function RecommendationsScreen() {
  const {
    catches,
    setActiveLocationId
  } = useApp();
  const recommendations = [{
    id: '1',
    title: 'Morning Bass',
    location: 'Emerald Lake',
    locationId: '1',
    match: 98,
    reason: 'Perfect conditions for bass fishing',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&q=80&w=800'
  }, {
    id: '2',
    title: 'Fly Fishing',
    location: 'Snake River',
    locationId: '2',
    match: 85,
    reason: 'Ideal water levels this weekend',
    image: 'https://images.unsplash.com/photo-1516961642265-531546e84af2?auto=format&fit=crop&q=80&w=800'
  }, {
    id: '3',
    title: 'Salmon Run',
    location: 'Misty Coast',
    locationId: '3',
    match: 92,
    reason: 'Peak salmon activity at high tide',
    image: 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&q=80&w=800'
  }];
  return <div className="p-4 md:p-8 max-w-2xl mx-auto pb-24 md:pb-8" data-id="element-236">
      <header className="mb-6" data-id="element-237">
        <h1 className="text-2xl font-semibold text-[var(--text-primary)]" data-id="element-238">
          For You
        </h1>
        <p className="text-[var(--text-secondary)] text-sm mt-1" data-id="element-239">
          Personalized recommendations
        </p>
      </header>

      {/* Recent Catches */}
      {catches.length > 0 && <div className="mb-8" data-id="element-240">
          <h2 className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-3" data-id="element-241">
            Recent catches
          </h2>
          <div className="flex space-x-3 overflow-x-auto pb-2" data-id="element-242">
            {catches.slice(0, 5).map((log, i) => <motion.div key={log.id} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: i * 0.05
        }} className="min-w-[140px] card p-3" data-id="element-243">
                <div className="flex items-center space-x-2 mb-2" data-id="element-244">
                  <Fish className="w-4 h-4 text-[var(--accent)]" data-id="element-245" />
                  <span className="text-sm font-medium text-[var(--text-primary)]" data-id="element-246">
                    {log.species}
                  </span>
                </div>
                <p className="text-xs text-[var(--text-muted)]" data-id="element-247">
                  {log.weight} lbs · {log.length}"
                </p>
              </motion.div>)}
          </div>
        </div>}

      {/* Recommendations */}
      <h2 className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-3" data-id="element-248">
        Recommended
      </h2>
      <div className="space-y-4" data-id="element-249">
        {recommendations.map((item, i) => <motion.div key={item.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: i * 0.1
      }} className="card overflow-hidden" data-id="element-250">
            <div className="relative h-32" data-id="element-251">
              <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-252" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-253" />
              <div className="absolute bottom-3 left-3 text-white" data-id="element-254">
                <p className="text-xs text-white/70 mb-0.5" data-id="element-255">{item.location}</p>
                <h3 className="font-semibold" data-id="element-256">{item.title}</h3>
              </div>
              <div className="absolute top-3 right-3 px-2 py-1 rounded-lg bg-white/20 backdrop-blur-sm text-white text-xs font-medium" data-id="element-257">
                {item.match}% match
              </div>
            </div>
            <div className="p-4 flex items-center justify-between" data-id="element-258">
              <p className="text-sm text-[var(--text-secondary)]" data-id="element-259">
                {item.reason}
              </p>
              <button onClick={() => setActiveLocationId(item.locationId)} className="p-2 rounded-xl bg-[var(--bg-secondary)] hover:bg-[var(--accent-light)] hover:text-[var(--accent)] transition-colors flex-shrink-0 ml-3" data-id="element-260">
                <ArrowRight className="w-4 h-4" data-id="element-261" />
              </button>
            </div>
          </motion.div>)}
      </div>

      {/* Seasons */}
      <div className="mt-8" data-id="element-262">
        <h2 className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-3" data-id="element-263">
          Upcoming seasons
        </h2>
        <div className="grid grid-cols-2 gap-3" data-id="element-264">
          {['Trout', 'Salmon', 'Bass', 'Crab'].map((fish, i) => <motion.div key={fish} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3 + i * 0.05
        }} className="card p-4 text-center" data-id="element-265">
              <div className="w-10 h-10 mx-auto mb-2 rounded-xl bg-[var(--bg-secondary)] flex items-center justify-center" data-id="element-266">
                <Fish className="w-5 h-5 text-[var(--accent)]" data-id="element-267" />
              </div>
              <p className="font-medium text-[var(--text-primary)] text-sm" data-id="element-268">
                {fish}
              </p>
              <p className="text-xs text-[var(--text-muted)]" data-id="element-269">12 days</p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}